import React, {memo} from 'react';
import DialogComponent from 'components/Dialog';
import {DialogTypes} from 'common/names';

import Button from '../../../../../components/Button';
import {Trans} from 'react-i18next';
import {Grid} from '@mui/material';
import {ReactFChildrenProps} from 'types/react/ReactFChildrenProps';
import {AuthPolicies} from 'features/layout/DialogRoutes/dialogs/UserAdmins/AuthPolicies';

type Props = {
   onClose: () => void;
};

const AuthPoliciesDialog: ReactFChildrenProps<Props> = memo((props) => {
   const {onClose} = props;

   return (
      <DialogComponent
         maxWidth="lg"
         header={DialogTypes.AuthPoliciesDialog.dialogName}
         close={onClose}
      >
         <AuthPolicies />
         <Grid container spacing={3} justifyContent="center">
            <Grid item>
               <Button type="button" onClick={onClose}>
                  <Trans>Close</Trans>
               </Button>
            </Grid>
         </Grid>
      </DialogComponent>
   );
});

export default AuthPoliciesDialog;
